import React from "react";
import PageBar from "../../components/dashboard/page-bar/PageBar";
import HistoryList from "../../components/history/HistoryList";

function ListHistory() {
  return (
    <>
      <div className="pageWrapper">
        <PageBar title="Login History" />
        
        <HistoryList />
      </div>
    </>
  );
}

export default ListHistory;
